import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../auth/auth.service';
import {WindowRefService} from '../../shared/window.service';
import {IntercomService} from '../../shared/intercom.service';
import {Subject, Observable} from 'rxjs';
import {StateService} from '../../shared/state/state.service';
import {UserSettingState} from '../../shared/state/user-setting.state';
import {DomSanitizer} from '@angular/platform-browser';
import {filter, takeUntil, map, take} from 'rxjs/operators';
import {BaseComponent} from '../../components/general/base/base.component';
import {OverlayPanelComponent} from '../../components/overlay-panel/overlay-panel.component';
import {version} from '../../../environments/version';
import { MapService } from '../../shared/map/map.service';
import { MapControl } from '../../shared/map/mapbox/utils/measure';


@Component({
  selector: 'qm-view-settings',
  templateUrl: './view-settings.component.html',
  styleUrls: ['./view-settings.component.scss']
})
export class ViewSettingsComponent extends BaseComponent implements OnInit, OnDestroy {

  public selectedTemplate: any;
  /**
   * user settings component
   */
  @ViewChild('controlOverlay', { static: true })
  public controlOverlay: OverlayPanelComponent;
  /**
   * Window instance, injected via service for mocking
   */
  private _window: any;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<boolean> = new Subject();
  public generalSettingsView: 'MAP' = 'MAP';
  public selectedMapTool: MapControl = 'addressSearch';
  public settings: UserSettingState;
  public selection: string;
  public dismissable: boolean = true;
  public version: string = version;
  private storedEvent: Event;
  public measureResult$: Observable<string>;

  /**
   * Default constructor
   * @param {TranslateService} translate
   * @param {WindowRefService} windowRef
   * @param {WeatherService} weatherService
   * @param {IntercomService} intercomService
   * @param {AuthService} auth
   * @param {AppMessageService} appMessageService
   * @param {ChangeDetectorRef} changeDetector
   * @param mapService
   * @param {StateService} stateService
   * @param sanitizer
   */
  constructor(private translate: TranslateService,
              windowRef: WindowRefService,
              private intercomService: IntercomService,
              private auth: AuthService,
              private mapService: MapService,
              private stateService: StateService,
              private sanitizer: DomSanitizer) {
    super();
    this.name = 'ViewSettingsComponent';
    this._window = windowRef.nativeWindow;
  }

  /**
   * Angular event, run when view is initialized (dom is rendered etc.)
   */
  ngOnInit() {
    this.settings = this.stateService.getPartOfState('settingsState');
    this.stateService.state$.pipe(takeUntil(this.ngUnsubscribe), filter(o => o.passesFilter('settingsState'))).subscribe(data => {
      if (data.getValue().size > 0) {
        this.settings = data.getValue();
      }
    });

    // initialize intercom when a session with the right perm is first encountered
    this.auth.login$.pipe(
      takeUntil(this.ngUnsubscribe),
      map(() => this.auth.hasPermission('intercom')),
      filter(hasPermission => hasPermission),
      take(1),
    ).subscribe(_ => {
      if (this.settings.screenMode === 0) {
        this.createIntercom();
      }
    });

    this.measureResult$ = this.mapService.measure.measureResult$;
  }

  /**
   * Angular destructor function
   */
  ngOnDestroy() {
    this.mapService.measure.setActiveControl(null);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private createIntercom() {
    setTimeout(async () => {
      if (this._window.Intercom) {
        this._window.intercomSettings = {
          app_id: 'y4du7m6o',
          alignment: 'right',
          language_override: 'fi',
          // horizontal_padding: document.documentElement.clientWidth / 100 * 8,
          // vertical_padding: document.documentElement.clientHeight - 645,
          hide_default_launcher: false
        };
        this._window.Intercom('boot', {
          app_id: 'y4du7m6o',
          email: this.auth.getEmail(),
          user_hash: (await this.intercomService.getIntercomHMAC(this.auth.getEmail())).hmac
        });
      }
    }, 1000);
  }

  /**
   * Turn measure distance mode on
   */
  public setMeasureDistanceOn() {
    console.log('MEASURE DISTANCE');
    this.mapService.measure.setActiveControl('distance');
    this.selectedMapTool = 'distance';
    this.dismissable = false;
    this.controlOverlay.show(this.storedEvent);
    console.log(this.controlOverlay);
  }

  /**
   * Turn measure area mode on
   */
  public setMeasureAreaOn() {
    console.log('MEASURE AREA', this.mapService.measure.getActiveControl());
    this.mapService.measure.setActiveControl('area');
    this.selectedMapTool = 'area';
    this.dismissable = false;
    this.controlOverlay.show(this.storedEvent);
    console.log(this.controlOverlay);
  }

  public toggleOverlay(template: any, event: Event): void {
    console.log('TOGGLE OVERLAY', template);
    console.log('TOGGLE OVERLAY', event);
    this.selectedTemplate = template;
    if (this.controlOverlay.visible) {
      this.clearMeasures();
      this.controlOverlay.hide();
      this.selectedMapTool = 'addressSearch';
    } else {
      this.controlOverlay.toggle(event);
      this.storedEvent = event;
    }
  }

  public clearMeasures() {
    this.dismissable = true;
    this.mapService.measure.setActiveControl(null);
  }

  public onClearBtnClicked() {
    // Reset the currently active control to clear the measurement
    const currentlyActiveControl = this.mapService.measure.getActiveControl();
    this.mapService.measure.setActiveControl(currentlyActiveControl);
  }

}
